
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Task } from "../../types/tasks";
import { TaskDetailView } from "./TaskDetailView";

interface TaskDetailDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  task: Task | null;
  isAdmin: boolean;
  isAdminView: boolean;
  currentUserId?: string;
  currentUserName?: string;
  currentUserAvatar?: string;
  onUpdateTask: (task: Task) => void;
  onAddComment: (taskId: string, content: string) => void;
  onRequestChange?: (taskId: string, requestType: "reassign" | "extend", details: string) => void;
  onChangeRequestResponse?: (taskId: string, requestId: string, approve: boolean) => void;
}

const TaskDetailDialog = ({
  isOpen,
  onOpenChange,
  task,
  isAdmin,
  isAdminView,
  currentUserId,
  currentUserName,
  currentUserAvatar,
  onUpdateTask,
  onAddComment,
  onRequestChange,
  onChangeRequestResponse
}: TaskDetailDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{isAdminView ? "Edit Task" : "Task Details"}</DialogTitle>
        </DialogHeader>
        {task && (
          <TaskDetailView 
            task={task}
            isAdmin={isAdmin}
            isAdminView={isAdminView}
            currentUserId={currentUserId}
            currentUserName={currentUserName}
            currentUserAvatar={currentUserAvatar}
            onUpdateTask={onUpdateTask}
            onAddComment={onAddComment}
            onRequestChange={onRequestChange}
            onChangeRequestResponse={onChangeRequestResponse}
            onClose={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TaskDetailDialog;
